export {RestangularModule} from './ng2-restangular.module';
export {Restangular} from './ng2-restangular';
export {RestangularHttp} from './ng2-restangular-http';
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
